/**
 * Extrai a idade numérica do paciente a partir do campo `Paciente.Idade`,
 * que pode vir como "30", "30 anos", vazio ou nulo.
 *
 * @param idade valor cru de `Paciente.Idade`
 * @returns a idade em dígitos (ex: "30") ou `undefined` quando não há idade válida
 */
export const extractPatientAge = (idade?: string | null): string | undefined => {
  if (!idade) return undefined;
  return idade.match(/\d+/)?.[0];
};
